<!-- Sidebar Modal -->
<div class="sidebar-modal">
    <div class="sidebar-modal-inner">
        <div class="sidebar-about-area">
            <div class="title">
                <h2>About EWNS</h2>
                <p>We believe SME's are the core strength for any economy and through our products & services, we try to empower SME's to get online, generate more business and drive consumers to their individual StoreFronts and there by help them to boost their Branding as well.</p>
            </div>
        </div>

        <div class="sidebar-instagram-feed">
            <h2>Instagram</h2>
            <ul>
                <li><a href="#" target="_blank"><img src="assets/img/blog-image/blog1.jpg" alt="image"></a></li>
                <li><a href="#" target="_blank"><img src="assets/img/blog-image/blog2.jpg" alt="image"></a></li>
                <li><a href="#" target="_blank"><img src="assets/img/blog-image/blog3.jpg" alt="image"></a></li>
                <li><a href="#" target="_blank"><img src="assets/img/blog-image/blog4.jpg" alt="image"></a></li>
                <li><a href="#" target="_blank"><img src="assets/img/blog-image/blog5.jpg" alt="image"></a></li>
                <li><a href="#" target="_blank"><img src="assets/img/blog-image/blog6.jpg" alt="image"></a></li>
                <li><a href="#" target="_blank"><img src="assets/img/blog-image/blog7.jpg" alt="image"></a></li>
                <li><a href="#" target="_blank"><img src="assets/img/blog-image/blog8.jpg" alt="image"></a></li>
            </ul>
        </div>

        <div class="sidebar-contact-area">
            <div class="contact-info">
                <div class="contact-info-content">
                    <h2>
                        <a href="tel:+919032526393" itemprop="telephone" title="call us">+91 90325 26393</a>
                        <span>OR</span>
                        <a href="mailto:sales@ewns.in" title="Email Us" itemprop="email">sales@ewns.in</a>
                    </h2>
                    <ul class="social">
                        <li><a href="#" target="_blank"><i class="fab fa-twitter"></i></a></li>
                        <li><a href="#" target="_blank"><i class="fab fa-youtube"></i></a></li>
                        <li><a href="https://www.facebook.com/ewns.in" title="Follow us on Facebook" target="_blank"><i class="fab fa-facebook-f"></i></a></li>
                        <li><a href="https://www.linkedin.com/company/ewnsdotin/" title="Follow us on LinkedIn" target="_blank"><i class="fab fa-linkedin-in"></i></a></li>
                        <li><a href="https://www.instagram.com/ewns.in/" title="Follow us on Instagram" target="_blank"><i class="fab fa-instagram"></i></a></li>
                    </ul>
                </div>
            </div>
        </div>

        <span class="close-btn sidebar-modal-close-btn"><i class="flaticon-close"></i></span>
    </div>
</div>
<!-- End Sidebar Modal -->